<template>
  <div v-if="!prdEnv()">
    <!--#region -- Header ---->
    <div>
      <div class="caption-label">
        <span class="mr-2">{{ function_name }} </span>
      </div>
      <div class="row">
        <div class="col">
          <div class="label mt-2">Context and Scenarios</div>

          <div class="row">
            <div class="col-12">
              <div class="sub-label">Describe Bug</div>
              <div class="w-900">
                <b-form-input class="w-850"
                              v-model="es_context"></b-form-input>
                <div v-if="es_context !== null" :class="classObject(es_context, 350)">
                  <span>You've input: {{ es_context | getInputLength }}/350</span>
                </div>
                <div v-else class="text-success">
                  <span>You've input: 0/350</span>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-12">
                  <b-button ref="focusButton" @click="callSimilarityService(es_context)" variant="primary"
                            @keyup.enter.prevent="callSimilarityService(es_context)" autofocus>
                    Search
                  </b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!------------------------------------>
    </div>

    <!-- end region -->
    <!-- #region: Semantic Search Result-->
    <div class="mt-3" v-if="similarityResult !== null && similarityResult !== ''">
      <div v-if="paperOutput !== '' && paperOutput !== null">
        <p class="my-4" style="color:gray" v-html="safeHtml(paperOutput)"></p>
      </div>
      <div v-else-if="paperOutput === '' && similarityResult !== '' && similarityResult !== null">
        <p class="my-4" style="color:gray" v-html="safeHtml(similarityResult)"></p>
      </div>
      <div v-else>
        <p class="my-4" style="color:gray" v-html="safeHtml(paper)"></p>
      </div>
    </div>
    <div class="mt-3" v-if="already_first_search_flag==true">

      <!--#region -- Result Count ---->

      <div class="d-flex">
        <div class="h5 font-weight-bold">{{ rows }} Results</div>
      </div>

      <!--#endregion -- Result Count ---->
      <!-- fix IE Browser min-height: 2.5rem -->
      <div class="table-responsive" style="min-height: 2.5rem">
        <b-table v-if="searchedData!==[]" :fields="fields" :items="searchedData"
                 small
                 thead-class="thead-light text-dark"
                 :busy="searching"
                 style="width: calc(100% - 10px)">

          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>

          <template #cell(similarity_score)="data">
            <div>
              <b-badge href="#" variant="success">{{data.item.similarity_score * 100}}</b-badge>
            </div>
          </template>
        </b-table>
      </div>
      <div class="d-flex pr-3">
        <div class="ml-auto">
          <b-pagination v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        :disabled="pageDisabled"
                        :limit="pageLimit"
                        @change="pageChange">
          </b-pagination>
        </div>
      </div>
      <div class="row mx-n1 align-items-center pr-3">
        <div class="px-1 col-auto ml-auto">
          Showing {{ 1 + (currentPage - 1) * perPage }} to {{ searchedData.length + (currentPage - 1) * perPage }} of {{rows}} rows
        </div>
        <div class="px-1 col-auto">
          <select class="form-control form-control-sm" v-model="perPage" v-on:change="perPageChange">
            <option>10</option>
            <option>20</option>
            <option>50</option>
            <option>100</option>
          </select>
        </div>
        <div class="px-1 col-auto">rows per page</div>
      </div>
    </div>
    <!--#endregion -- Body ---->
  </div>

  <div v-else class="coming-soon-page">
    <div class="coming-soon-card">

      <!-- Animated icon -->
      <div class="cs-icon-area">
        <div class="cs-icon-ring">
          <i class="fa fa-cogs cs-cog-icon"></i>
        </div>
        <div class="cs-steam-row">
          <span class="cs-steam"></span>
          <span class="cs-steam"></span>
          <span class="cs-steam"></span>
        </div>
      </div>

      <!-- Brand badge -->
      <div class="cs-brand-badge">
        <img src="https://www.getac.com/img/getac-logo.png"
             alt="Getac"
             class="cs-brand-logo"
             onerror="this.style.display='none'" />
        <span class="cs-brand-text">Getac On-Premise AI · Genova</span>
      </div>

      <!-- Heading -->
      <h1 class="cs-title">We're Cooking Something Great</h1>
      <p class="cs-subtitle">
        This feature is currently under active development and not yet available in this environment.<br />
        Our engineering team is working hard to bring you a powerful AI-enhanced experience.
      </p>

      <!-- Progress bar -->
      <div class="cs-progress-wrap">
        <div class="cs-progress-label d-flex justify-content-between mb-1">
          <span><i class="fa fa-code mr-1"></i>Development in progress</span>
          <span class="cs-progress-pct">In Dev</span>
        </div>
        <div class="cs-progress-track">
          <div class="cs-progress-bar"></div>
        </div>
      </div>

      <!-- Info chips -->
      <div class="cs-chips">
        <span class="cs-chip cs-chip-orange"><i class="fa fa-bolt mr-1"></i>AI Enhanced</span>
        <span class="cs-chip cs-chip-blue"><i class="fa fa-lock mr-1"></i>Pre-Production</span>
        <span class="cs-chip cs-chip-gray"><i class="fa fa-clock-o mr-1"></i>Launching Soon</span>
      </div>

    </div>
  </div>
</template>

<script>
  import * as moment from 'moment/moment';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    name: 'ftie-ai-navigator',
    data() {
      return {
        function_name: 'FTIE AI Overview',
        dateFormat: { year: 'numeric', month: 'short', day: 'numeric' },
        keywords: '',
        es_context: '',
        input_to_copilot_studio_agent: '',
        customer: '',
        authUrl: '',
        frontendUrl: '',
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        userInfo: '',
        userFunctions: [],
        userRoles: [],
        userSites: [],
        date_from: '',
        date_to: '',
        GRO_options_default: '',
        GRO_options: [
          { value: '', text: 'ALL' },
          { value: 'GDE', text: 'GDE' },
          { value: 'Getac', text: 'Getac' },
          { value: 'GFR', text: 'GFR' },
          { value: 'GMD-AFME', text: 'GMD-AFME' },
          { value: 'GMD-AU', text: 'GMD-AU' },
          { value: 'GMD-E.ASIA', text: 'GMD-E.ASIA' },
          { value: 'GMD-IN', text: 'GMD-IN' },
          { value: 'GMD-IT', text: 'GMD-IT' },
          { value: 'GMD-LATAM', text: 'GMD-LATAM' },
          { value: 'GMD-CISCEE', text: 'GMD-CISCEE' },
          { value: 'GMD-S.ASIA', text: 'GMD-S.ASIA' },
          { value: 'GMD-W.EU', text: 'GMD-W.EU' },
          { value: 'GML', text: 'GML' },
          { value: 'GTK', text: 'GTK' },
          { value: 'GUK', text: 'GUK' },
          { value: 'GUSA', text: 'GUSA' },
          { value: 'OTHERS', text: 'OTHERS' },
        ],
        GRO: '',
        GROText: '',
        GTCOwnerList: [],
        GROOwnerList: [],
        OriginGroOwnerList: [],
        model_options: [],
        ftieTypeList: [],
        ftieTypeOptions: [],
        KeyWordCategoryList: ['Basic Info', 'Bios/EC', 'SN', 'Subject'],
        model: '',
        loadingCnt: 0,

        my_status_options: [{ value: 'InProgress', text: 'In Progress' }, { value: 'Oncoming', text: 'Oncoming' }],
        my_status: '',

        NRE_status_options: [],
        NRE_status: [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }],

        //ticket_type_options: ['ALL', 'Pre-sales', 'Post-sales', 'Customization Support', 'Sector Solution'],
        ticket_type_options: [
          { value: '3rd Party Solution', text: '3rd Party Solution' },
          { value: 'Customization Support', text: 'Customization Support' },
          { value: 'Development Documents', text: 'Development Documents' },
          { value: 'Technical Inquiry', text: 'Technical Inquiry' },
          { value: 'Technical Issue', text: 'Technical Issue' },
          { value: 'Technical Support', text: 'Technical Support' }],
        ticket_type: '',

        ticket_status_options: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }],
        ticket_status: [{ value: 'New', text: 'New' }, { value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }],

        reason_text: null,

        already_first_search_flag: false,
        fields: [
          { key: 'SCORE', label: 'AI Score', thClass: 'align-middle', sortable: true },
          { key: 'BUG_ID', label: 'Bug ID', thClass: 'align-middle', thStyle: { 'min-width': '6.5rem !important' }, sortable: true },
          { key: 'PROJECT_NAME', label: 'Project NAME', thClass: 'align-middle', sortable: true },
          //{ key: 'ISSUE_TYPE', label: 'Issue Type', thClass: 'align-middle', sortable: true },
          //{ key: 'STATUS', label: 'Status', thClass: 'align-middle', sortable: true },
          //{ key: 'PROJECT_STAAGE', label: 'Project Stage', thClass: 'align-middle', sortable: true },
          //{ key: 'BUG_CREATOR', label: 'Bug Creator', thClass: 'align-middle', sortable: true },
          //{ key: 'BUG_PRIORITY', label: 'Priority', thClass: 'align-middle', sortable: true },
          { key: 'BUG_DESCRIPTION', label: 'Bug Desc', thClass: 'align-middle', sortable: true },
          //{ key: 'CREATE_DATE', label: 'Create Date', thClass: 'align-middle', sortable: true },
        ],
        searchByFtieId: null,
        searchedData: [],
        GRO_owner: '',
        GTC_owner: 'ALL',
        login_user_name: '',
        searching: false,
        pageDisabled: false,
        pageLimit: 10,
        perPage: 10,
        currentPage: 1,
        totalCount: '',
        closeSubTicketFTIE: null,
        closeSubTicketReason: '',
        keyword_category: 'Basic Info',
        similarityResult: null,
        copilotStudioAgentResponse: null,
        printerForOutputText: '',
        paper: '',
        paperOutput: '',
        printerForOutputTextAgent: '',
        paperAgent: '',
        paperOutputAgent: '',
        timer: null,
        aiDraftProposal: '',
        ai_proposal_loading: false,
      }
    },
    created() {
      let self = this;


    },
    computed: {
      rows() {
        return this.totalCount
        //return this.searchedData.length
      },
      date_from_computed() {
        let str = moment(this.date_from, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      date_to_computed() {
        let str = moment(this.date_to, 'YYYY-MMM-DD').format('YYYY-MM-DD');
        if (str === 'Invalid date') return '';
        else return str;
      },
      chosen_keyword_category() {
        let self = this;

        if (self.keyword_category === 'Basic Info') return 'IDs, PNs';
        else return self.keyword_category;
      }
    },
    mounted: function () {
      this.checkLoggedIn();
      this.authUrl = this.$options.filters['authUrl']();
      this.frontendUrl = this.$options.filters['frontendUrl']();
      this.loadingCnt = 0;
      this.get_ftie_owner_list();
      if (this.$route.params.ftieId) {
        //this.keywords = this.$route.params.keywords;
        this.searchByFtieId = this.$route.params.ftieId;
        console.log("this.searchByFtieId = ");
        console.log(this.searchByFtieId);
        this.search();
      }
    },
    watch: {
      paper: function () {
        if (this.paper.length == this.titleText.length) {
          this.paper = ''
        }
      },
      paperOutput: function () {
        if (this.paperOutput.length == this.printerForOutputText.length) {
          this.paperOutput = '';
          this.printerForOutputText = '';
          this.stoperOutput();
        }
      },
      paperAgent: function () {
        if (this.paperAgent.length == this.titleText.length) {
          this.paperAgent = ''
        }
      },
      paperOutputAgent: function () {
        if (this.paperOutputAgent.length == this.printerForOutputTextAgent.length) {
          this.paperOutputAgent = '';
          this.printerForOutputTextAgent = '';
          this.stoperOutput();
        }
      },
    },

    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      ifShowOptyLink(recordSite) {
        let self = this;
        if (self.reportAccess()) {
          return true;
        } else {
          if (self.userSites !== null && self.userSites.includes(recordSite)) {
            return true;
          }
        }
        return false;
      },
      pageViewAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_functions && _.indexOf(user_functions, 'Tech Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("pageView Access!");
          return true
        }
        return false;
      },

      reportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');
        if ((user_site && _.indexOf(user_site, 'Getac') > -1) && (
          (user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1)
          || (user_functions && _.indexOf(user_functions, 'Tech Leader') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
        )
        ) {
          console.log("Access to report!");
          return true
        }
        return false;
      },

      get_ftie_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        let gro_owner_list = [];
        self.$axios.get(url, { params }, {
          headers: {
            "Authorization": `Token ${self.$store.state.token}`,
          }
        })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gtc_owner_list = JSON.parse(res['gtc_owner_list']);
              gro_owner_list = JSON.parse(res['gro_owner_list']);
              self.GTCOwnerList = gtc_owner_list;
              self.GTCOwnerList.unshift('ALL');

              self.OriginGroOwnerList = gro_owner_list;
              const distinctValues = _.uniq(_.map(gro_owner_list, 'member_gulid'));
              self.GROOwnerList = distinctValues;
              self.GROOwnerList.unshift('ALL');
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            }
            else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            if ((self.userSites && _.indexOf(self.userSites, 'Getac') > -1)) {
              if (self.GTCOwnerList && _.indexOf(self.GTCOwnerList, self.login_user_name) > -1) {
                self.GTC_owner = self.login_user_name;
              }
              else {
                self.GTC_owner = 'ALL';
              }
            }
            self.GRO_owner = 'ALL';
            //self.search();
            eventHub.$emit('loading', false);
          });
      },
      setDefaultDateForSearching() {
        console.log("setDefaultDateForSearching");
        let self = this;
        //let today = moment();
        let defaultStartDate = moment().subtract(2, 'months');
        self.date_from = defaultStartDate.format('YYYY-MMM-DD');
        self.date_to = moment().format('YYYY-MMM-DD');
      },
      logout() {
        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            this.$router.push("/");
          })
        window.location = self.frontEndUrlToUse + 'azure-login';
      },
      checkLoggedIn() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        console.log("this.$session.get('options')");
        console.log(options);
        console.log(options.model_list);
        console.log("login_user_name:");
        console.log(user_name);
        console.log("user_email:");
        console.log(user_email);
        console.log("user_functions:");
        console.log(user_functions);
        console.log("user_roles:");
        console.log(user_roles);
        console.log("user_site:");
        console.log(user_site);


        this.login_user_name = user_name;
        //this.GTCOwnerList = options.gtc_owner_opt_list;
        this.GROOwnerList = options.gro_owner_opt_list;
        this.ownerSelectionDic = options.owner_dic_with_region_key;
        this.ftieTypeList = options.ftie_type_list;
        console.log("options.ftie_type_list:");
        console.log(options.ftie_type_list);

        console.log("options.gtc_owner_default:");
        console.log(options.gtc_owner_default);
        console.log("options.gro_owner_default:");
        console.log(options.gro_owner_default);

        this.GTC_owner = options.gtc_owner_default;
        this.GRO_owner = options.gro_owner_default;

        //console.log("GTCOwnerList:");
        //console.log(this.GTCOwnerList);
        //console.log("GROOwnerList:");
        //console.log(this.GROOwnerList);

        this.userFunctions = user_functions;
        this.userRoles = user_roles;
        this.userSites = user_site;
        var i;
        var model_option_new = new Array();
        for (i = 0; i < options.model_list.length; i++) {
          model_option_new.push({ value: options.model_list[i], text: options.model_list[i] })
        }
        this.model_options = this.model_options.concat(model_option_new);

        var ticketTypeOptionTmp = new Array();
        for (i = 0; i < options.ftie_type_list.length; i++) {
          ticketTypeOptionTmp.push({ value: options.ftie_type_list[i], text: options.ftie_type_list[i] })
        }
        this.ftieTypeOptions = this.ftieTypeOptions.concat(ticketTypeOptionTmp);
      },

      search() {
        if (this.loadingCnt == 0) {
          this.already_first_search_flag = false;
          this.loadingCnt = this.loadingCnt + 1;
        }
        this.currentPage = 1;
        this.getFties();
      },
      pageChange(page) {
        this.currentPage = page
        this.getFties() // api call
      },
      perPageChange() {
        this.currentPage = 1;
        this.getFties() // api call
      },

      printerOutput() { // put start function herep
        this.stoperOutput();
        let i = -1;
        this.timer = setInterval(() => {
          if (i === -1) {
            this.paperOutput = ' ';
          }
          i++;
          if (i === 0) {
            this.paperOutput = '';
          }
          const x = i % this.printerForOutputText.length;
          this.paperOutput += this.printerForOutputText[x]
        }, 30)
      },

      stoperOutput() { // put stop functions here
        clearInterval(this.timer);
        this.paperOutput = ''
      },

      printer() { // put start function herep
        this.stoper();
        let i = -1;
        this.timer = setInterval(() => {
          i++
          const x = i % this.titleText.length
          this.paper += this.titleText[x]
        }, 200)
      },
      stoper() { // put stop functions here
        clearInterval(this.timer);
        this.paper = ''
      },

      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      callAIDraftProposal(content) {
        let self = this;
        let resultText = null;
        let url_NOVACORE_EMBEDDING = self.$root.baseUrl + '/ai-service/similarity/';
        let url = self.$root.baseUrl + '/ai-service/ai-proposal/';
        self.ai_proposal_loading = true;
        var similarFtieIdList = new Array();
        var i;
        if (self.searchedData !== [] && self.searchedData !== null && self.searchedData.length > 0) {
          for (i = 0; i < self.searchedData.length; i++) {
            similarFtieIdList.push(self.searchedData[i]['ftie_id'])
          }
        }
        let request_data = {
          ftie_id: '',
          similar_ftie_id_list: similarFtieIdList,
          ftie_info_list: self.searchedData,
          site: self.userSites,
          es_query: content
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        // eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['draft_proposal'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            // eventHub.$emit('loading', false);
            self.ai_proposal_loading = false;
            self.aiDraftProposal = resultText;
          })
      },

      callCopilotStudioAgent(content) {
        let self = this;
        let resultText = null;
        let searchedData = null;
        let totalCount = 0;
        // let url_NOVACORE_EMBEDDING = self.$root.baseUrl + '/ai-service/similarity/';
        let url_python_ora23VDB_EMBEDDING = self.$root.baseUrl + '/ai-service/copilot-studio-agent/';
        let url = url_python_ora23VDB_EMBEDDING;
        var model_selected = [];
        if (self.model.length !== 0) {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }
        let request_data = {
          ftie_id: '',
          context: content,
          sfdc_request_type: '',
          es_description: content,
          es_issue_req: content,
          device: model_selected,
          site: self.GRO,
          vertical: ''
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['agent_result'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {

            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            // self.searchedData = searchedData;
            // self.totalCount = totalCount;
            self.copilotStudioAgentResponse = resultText;
            self.printerForOutputTextAgent = resultText;
          })

      },

      callSimilarityService(content) {
        let self = this;
        let resultText = null;
        let searchedData = null;
        let totalCount = 0;
        let url_NOVACORE_EMBEDDING = self.$root.baseUrl + '/ai-service/similarity/';
        let url_python_ora23VDB_EMBEDDING = self.$root.baseUrl + '/ai-service/vector-db/pdc-semantic-search/';
        let url = url_python_ora23VDB_EMBEDDING;
        let request_data = {
          context: content
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['similarity_response'];
              searchedData = JSON.parse(res['bug_list']); //ftie_info_list
              totalCount = parseInt(searchedData[0].total_count);
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {

            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.totalCount = totalCount;
            self.similarityResult = resultText;
            self.printerForOutputText = resultText;

          })

      },

      getFties() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/list/';
        console.log('####getFties######');
        var model_selected = [];
        var ticket_type_selected = [];
        var ticket_status_selected = [];
        var my_status_selected = [];
        var i;
        if (self.model.length == 0) {
          model_selected.push("")
        } else {
          for (i = 0; i < self.model.length; i++) {
            model_selected.push(self.model[i]['value'])
          }
        }

        if (self.ticket_status.length == 0) {
          ticket_status_selected.push("")
        }
        else {
          for (i = 0; i < self.ticket_status.length; i++) {
            ticket_status_selected.push(self.ticket_status[i]['value'])
          }
        }

        if (self.ticket_type.length == 0) {
          ticket_type_selected = ['']
        }
        else {
          for (i = 0; i < self.ticket_type.length; i++) {
            ticket_type_selected.push(self.ticket_type[i]['value'])
          }
        }

        let request_data = {
          model_selected: model_selected,
          ticket_type_selected: ticket_type_selected,
          ticket_status_selected: ticket_status_selected,
          /*my_status_selected: my_status_selected,*/
          record_per_page: self.perPage,
          page_index: self.currentPage,
          GRO: self.GRO,
          GRO_owner: self.GRO_owner,
          GTC_owner: self.GTC_owner,
          date_from: self.date_from_computed,
          date_to: self.date_to_computed,
          keywords: self.keywords,
          customer: self.customer,
          search_by_ftie_id: self.searchByFtieId,
          login_user_name: self.login_user_name,
          search_type: 'List',
          keyword_category: self.keyword_category
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };

        self.searching = true;
        let searchedData = [];
        //let nreTotalCount = 2;
        let totalCount = 0;

        if (self.already_first_search_flag == false) {
          eventHub.$emit('loading', true);
        }
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              searchedData = JSON.parse(res['ftie_list']); //ftie_info_list
              totalCount = parseInt(searchedData[0].total_count);
              //console.log(searchedData);
            }

            else if (response.status === 204) {
              self.$message.warning('No data found! Please try other selection or click reset to search all.', self.function_name);
              console.log(res.description);
            }

            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searching = false;
            self.already_first_search_flag = true;
            if (self.already_first_search_flag == true) {
              eventHub.$emit('loading', false);
            }
            self.searchedData = searchedData;
            self.totalCount = totalCount;
          })
      },
      resetFilterCondition() {
        let self = this;
        self.keywords = '';
        self.my_status = [];
        self.model = '';
        //self.GRO = '';
        self.GRO_owner = 'ALL';
        self.GTC_owner = 'ALL';
        self.date_from = '';
        self.date_to = '';
        //self.NRE_status = [{ value: 'Waiting', text: 'Ongoing' }, { value: 'W', text: 'Awaiting' }];//{Ongoing, Waiting}
        self.NRE_status = [{ value: "Waiting", text: "Ongoing" }, { value: "W", text: "Awaiting" }, { value: "Completed", text: "Completed" }, { value: "Rejected", text: "Rejected" }, { value: "Deferred", text: "Deferred" }];
        self.ticket_status = [{ value: 'Open', text: 'Open' }, { value: 'Solved', text: 'Solved' }, { value: 'Close', text: 'Closed' }, { value: 'Deferred', text: 'Deferred' }]; //{Open, Solved, Closed, Deferred}
        self.my_status = [];
        if (self.searchByFtieId !== null) {
          self.searchByFtieId = null;
          self.$router.push('/ftie/ftie-dashboard');
        }
        self.searchByFtieId = null;

      },
      redirectToEtoDashboard(ftie_id) {
        let self = this;
        console.log(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
        window.open(self.frontendUrl + 'dashboard/' + encodeURIComponent(ftie_id));
      },
      showCloseSubTicketModal(ftie_id) {
        let self = this;
        self.closeSubTicketFTIE = ftie_id;
        self.closeSubTicketReason = '';
        self.$refs['CloseSubTicketModal'].show()
      },
      closeSubTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/close-sub-ticket/';

        let request_data = {
          ftie_id: self.closeSubTicketFTIE,
          close_reason: self.closeSubTicketReason
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              self.getFties()
            }
          })
        self.$nextTick(() => {
          self.$refs['CloseSubTicketModal'].hide();
        })
      },
      unreadRowClass(item, type) {
        if (item && type === 'row') {
          let unread_sub_tickets = [];
          if (item.sub_tickets.length > 0) {
            unread_sub_tickets = _.reject(item.sub_tickets, { 'unread_ftie_id': null });
          }
          if (item.unread_flag || unread_sub_tickets.length > 0) {
            return 'table-row-highlight table-row-bold'
          } else {
            return null
          }
        } else {
          return null
        }
      },
      getRelatedGroOwner() {
        let self = this;
        let groOptions = _.filter(self.OriginGroOwnerList, item => item.site == self.GRO || self.GRO == '');
        self.GROOwnerList = _.uniq(_.map(groOptions, function (item) {
          return item.member_gulid;
        }));
        self.GRO_owner = 'ALL';
        self.GROOwnerList.unshift('ALL');
      },

      focusButton() {
        // 重新聚焦按鈕
        setTimeout(() => {
          this.$refs.focusButton.focus();
        }, 100);
      },
    },
    filters: {

    }
  }
</script>
<style scoped>
  /* ========================================
 COMING SOON PAGE
 ======================================== */
  .coming-soon-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #fdf6f0 0%, #f0f4f8 100%);
    padding: 2rem 1rem;
  }

  .coming-soon-card {
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.10);
    padding: 3rem 2.5rem 2.5rem;
    max-width: 520px;
    width: 100%;
    text-align: center;
    border-top: 4px solid #f77530;
  }

  /* --- Icon area --- */
  .cs-icon-area {
    margin-bottom: 1.2rem;
  }

  .cs-icon-ring {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #fff3ec, #ffe5d0);
    border: 2px solid rgba(247, 117, 48, 0.25);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.4rem;
  }

  .cs-cog-icon {
    font-size: 2.2rem;
    color: #f77530;
    animation: cs-spin 6s linear infinite;
  }

  @keyframes cs-spin {
    from {
      transform: rotate(0deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .cs-steam-row {
    display: flex;
    justify-content: center;
    gap: 8px;
  }

  .cs-steam {
    display: inline-block;
    width: 5px;
    height: 16px;
    background: #f77530;
    border-radius: 4px;
    opacity: 0;
    animation: cs-steam-rise 1.8s ease-in-out infinite;
  }

    .cs-steam:nth-child(2) {
      animation-delay: 0.35s;
    }

    .cs-steam:nth-child(3) {
      animation-delay: 0.7s;
    }

  @keyframes cs-steam-rise {
    0% {
      transform: translateY(0);
      opacity: 0;
    }

    40% {
      transform: translateY(-8px);
      opacity: 0.5;
    }

    100% {
      transform: translateY(-18px);
      opacity: 0;
    }
  }

  /* --- Brand badge --- */
  .cs-brand-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 999px;
    padding: 0.3rem 0.9rem;
    margin-bottom: 1.2rem;
  }

  .cs-brand-logo {
    height: 16px;
    object-fit: contain;
  }

  .cs-brand-text {
    font-size: 0.72rem;
    font-weight: 600;
    color: #6c757d;
    letter-spacing: 0.03em;
  }

  /* --- Text --- */
  .cs-title {
    font-size: 1.5rem;
    font-weight: 700;
    color: #2d3748;
    margin-bottom: 0.75rem;
  }

  .cs-subtitle {
    font-size: 0.88rem;
    color: #718096;
    line-height: 1.7;
    margin-bottom: 1.6rem;
  }

  /* --- Progress bar --- */
  .cs-progress-wrap {
    margin-bottom: 1.6rem;
    text-align: left;
  }

  .cs-progress-label {
    font-size: 0.75rem;
    color: #888;
    font-weight: 600;
  }

  .cs-progress-pct {
    color: #f77530;
    font-weight: 700;
  }

  .cs-progress-track {
    height: 8px;
    background: #f0f0f0;
    border-radius: 999px;
    overflow: hidden;
  }

  .cs-progress-bar {
    height: 100%;
    width: 65%;
    background: linear-gradient(90deg, #f77530, #e05a10);
    border-radius: 999px;
    animation: cs-progress-pulse 3s ease-in-out infinite;
  }

  /*  ======================================== */
</style>



// WEBPACK FOOTER //
// src/components/framework-gen-ai/PdcAINavigator.vue